import React from 'react';
import { useNavigate } from 'react-router-dom';

const GetOffer: React.FC = () => {
    const navigate = useNavigate();

    const handleAppraisalClick = () => {
        navigate('/car-appraisal');
    };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <section className="bg-red-600 text-white py-16">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">We buy any car for cash</h1>
                    <p className="text-xl mb-8">Are you looking to sell your car in California?</p>
                    <button 
                        onClick={handleAppraisalClick}
                        className="bg-white text-red-600 px-8 py-3 rounded-md font-bold text-lg hover:bg-gray-100 transition"
                    >
                        APPRAISE YOUR CAR
                    </button>
                </div>
            </section>

            {/* How it Works Section */}
            <section className="py-16">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12">How it works</h2>
                    
                    <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                        {/* Step 1 */}
                        <div className="bg-white p-6 rounded-lg shadow-md text-center">
                            <div className="text-4xl font-bold text-red-600 mb-4">1</div>
                            <h3 className="text-xl font-bold mb-3">Get an offer Quickly</h3>
                            <i className="fas fa-money-check-dollar text-2xl text-red-600 mb-4"></i>
                            <p className="text-gray-600">Quick car evaluation without the hassle.</p>
                        </div>

                        {/* Step 2 */}
                        <div className="bg-white p-6 rounded-lg shadow-md text-center">
                            <div className="text-4xl font-bold text-red-600 mb-4">2</div>
                            <h3 className="text-xl font-bold mb-3">We come to you or make an appointment to visit our location</h3>
                            <i className="fas fa-building text-2xl text-red-600 mb-4"></i>
                            <p className="text-gray-600">You don't have to pay for towing. We take care of all towing fees.</p>
                        </div>

                        {/* Step 3 */}
                        <div className="bg-white p-6 rounded-lg shadow-md text-center">
                            <div className="text-4xl font-bold text-red-600 mb-4">3</div>
                            <h3 className="text-xl font-bold mb-3">Get paid today</h3>
                            <i className="fas fa-wallet text-2xl text-red-600 mb-4"></i>
                            <p className="text-gray-600">Immediate payment and cash in hand. Your offer is always GUARANTEED.</p>
                        </div>
                    </div>

                    <div className="text-center mt-12">
                        <button className="bg-red-600 text-white px-8 py-3 rounded-md font-bold text-lg hover:bg-red-700 transition">
                            SCHEDULE MY APPOINTMENT
                        </button>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="bg-gray-100 py-16">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-6">Why Sell Your Car To Drive Today Auto</h2>
                    <p className="text-gray-600 text-center max-w-4xl mx-auto mb-12 leading-relaxed">
                        When you're in a pinch, selling your car quickly shouldn't mean settling for less. Many car buying companies in California offer far below market value—but at Drive Today Auto, we believe you deserve a fair deal. We're here to make sure you get what your car is truly worth.
                    </p>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <i className="fas fa-check-circle text-2xl text-red-600 mb-4"></i>
                            <h3 className="text-xl font-bold mb-2">Guaranteed quotes.Best prices paid and less hassle.</h3>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <i className="fas fa-car text-2xl text-red-600 mb-4"></i>
                            <h3 className="text-xl font-bold mb-2">We buy your car regardless of the make, model or car condition.</h3>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <i className="fas fa-money-bill-wave text-2xl text-red-600 mb-4"></i>
                            <h3 className="text-xl font-bold mb-2">Our company is in a position to give you more cash for your car.</h3>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <i className="fas fa-clock text-2xl text-red-600 mb-4"></i>
                            <h3 className="text-xl font-bold mb-2">Once you accept your offer we will pay you QUICKLY.</h3>
                        </div>
                    </div>
                </div>
            </section>

            {/* Appointment Form */}
            <section className="py-16">
                <div className="container mx-auto px-4">
                    <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-md">
                        <h2 className="text-3xl font-bold text-center mb-8">Schedule an Appointment</h2>
                        <form className="space-y-4">
                            <div className="grid md:grid-cols-2 gap-4">
                                <input type="text" placeholder="First Name" className="w-full px-4 py-2 border rounded-md" />
                                <input type="text" placeholder="Last Name" className="w-full px-4 py-2 border rounded-md" />
                            </div>
                            <input type="email" placeholder="Email Address" className="w-full px-4 py-2 border rounded-md" />
                            <input type="tel" placeholder="Phone Number" className="w-full px-4 py-2 border rounded-md" />
                            <div className="grid md:grid-cols-2 gap-4">
                                <input type="text" placeholder="Vehicle Year" className="w-full px-4 py-2 border rounded-md" />
                                <input type="text" placeholder="Vehicle Make" className="w-full px-4 py-2 border rounded-md" />
                            </div>
                            <div className="grid md:grid-cols-2 gap-4">
                                <input type="text" placeholder="Vehicle Model" className="w-full px-4 py-2 border rounded-md" />
                                <input type="text" placeholder="Mileage" className="w-full px-4 py-2 border rounded-md" />
                            </div>
                            <select className="w-full px-4 py-2 border rounded-md">
                                <option value="">Title Status</option>
                                <option value="clean">Clean Title</option>
                                <option value="salvage">Salvage Title</option>
                                <option value="missing">Missing Title</option>
                            </select>
                            <textarea placeholder="Notes" className="w-full px-4 py-2 border rounded-md h-32"></textarea>
                            <button type="submit" className="w-full bg-red-600 text-white px-8 py-3 rounded-md font-bold text-lg hover:bg-red-700 transition">
                                Schedule Appointment
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default GetOffer; 